// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";
import * as PilotClozeDragBucketContainer$LiteracyplanetTupperware from "./PilotClozeDragBucketContainer.res.mjs";

function SkilfulClozeDragBucketContainer$Skilful__$ResponseContainer(props) {
  return React.createElement("span", {
              className: Skillet$LiteracyplanetTupperware.SkilfulClozeDragTextContainer.ResponseContainer.className,
              onClick: props.onClick
            }, props.children);
}

var ResponseContainer = {
  make: SkilfulClozeDragBucketContainer$Skilful__$ResponseContainer
};

function SkilfulClozeDragBucketContainer$Skilful__(props) {
  return React.createElement(SkilfulClozeDragBucketContainer$Skilful__$ResponseContainer, {
              children: React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drag.make, {
                    index: props.index,
                    id: props.id,
                    children: props.children
                  })
            });
}

var Skilful__ = {
  ResponseContainer: ResponseContainer,
  make: SkilfulClozeDragBucketContainer$Skilful__
};

function SkilfulClozeDragBucketContainer(props) {
  var children = props.children;
  var id = props.id;
  var __index = props.index;
  var index = __index !== undefined ? __index : 0;
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(PilotClozeDragBucketContainer$LiteracyplanetTupperware.make, {
                index: index,
                id: id,
                children: children
              });
  } else {
    return React.createElement(SkilfulClozeDragBucketContainer$Skilful__, {
                index: index,
                id: id,
                children: children
              });
  }
}

var make = SkilfulClozeDragBucketContainer;

var $$default = SkilfulClozeDragBucketContainer;

export {
  Skilful__ ,
  make ,
  $$default as default,
}
/* react Not a pure module */
